import * as yup from 'yup'

const IncidentFormScheme = {
  TYPE: yup.object().shape({
    isInfrastructure: yup.string().required('errors.form.empty'),
  }),
  POSITION: yup.object().shape({
    space: yup.string().required('errors.form.empty'),
  }),
  LOCATION: yup.object().shape({
    location: yup.string().required('errors.form.empty'),
    subLocation: yup.string(),
    subsubLocation: yup.string(),
  }),
  ACTIVITY: yup.object().shape({
    familles: yup.array().of(yup.string().required('errors.form.empty')).min(1, 'errors.form.empty'),
  }),
  ACTIVITY_DETAIL: yup.object().shape({
    familles: yup.array().of(yup.string().required('errors.form.empty')),
  }),
  DETAIL: yup.object().shape({
    commentaire: yup.string(),
    quantite: yup.number().required('errors.form.empty'),
    isPrioritaire: yup.boolean(),
  }),
  PHOTO: yup.object().shape({
    photos: yup.array(),
  }),
  PRESTA: yup.object().shape({
    societePrestataireId: yup.string().required('errors.form.empty'),
  }),
  RECAP: yup.object().shape({}),
  MANIF: yup.object().shape({
    manifestationId: yup.string(),
  }),
  COMMAND_SEARCH: yup.object().shape({
    enseigneCommande: yup.string().when(['commandSearch'], {
      is: (commandSearch: 'location' | 'name') => commandSearch === 'name',
      then: yup.string().required('errors.form.empty'),
      otherwise: yup.string(),
    }),
    enseignes: yup
      .array()
      .of(yup.string())
      .when(['commandSearch'], {
        is: (commandSearch: 'location' | 'name') => commandSearch === 'location',
        then: yup.array().of(yup.string().required('errors.form.empty')).min(1, 'errors.form.empty'),
        otherwise: yup.array().of(yup.string()),
      }),
  }),
  USER: yup.object().shape({
    user: yup.string().required('errors.form.empty'),
  }),
  USER_DETAIL: yup.object().shape({
    nomContact: yup.string().required('errors.form.empty'),
    prenomContact: yup.string().required('errors.form.empty'),
    emailContact: yup.string().required('errors.form.empty').email('errors.form.email'),
    telephoneContact: yup.string().required('errors.form.empty'),
  }),
  COMMAND: yup.object().shape({
    numeroCommande: yup.string().required('errors.form.empty'),
    referenceArticleCommande: yup.string().required('errors.form.empty'),
  }),
  SITE: yup.object().shape({
    siteId: yup.string().required('errors.form.empty'),
  }),
  MAP: yup.object().shape({
    // plan: yup.object().shape({
    //   x: yup.string().required('error.form.empty'),
    //   y: yup.string().required('error.form.empty'),
    // }),
  }),
  SITE_EXPO: yup.object().shape({
    siteId: yup.string().required('errors.form.empty'),
  }),
  MANIF_EXPO: yup.object().shape({
    manifestationId: yup.string().required('errors.form.empty'),
  }),
  COMMAND_EXPO: yup.object().shape({
    libelleFamille: yup.string().required('errors.form.empty'),
    libelleSousFamille: yup.string().required('errors.form.empty'),
    libelleArticle: yup.string().required('errors.form.empty'),
  }),
  COMMAND_SEARCH_EXPO: yup.object().shape({
    enseigneCommande: yup.string().when(['commandSearch'], {
      is: (commandSearch: 'location' | 'name') => commandSearch === 'name',
      then: yup.string().required('errors.form.empty'),
      otherwise: yup.string(),
    }),
    espaceCommande: yup.string().when(['commandSearch'], {
      is: (commandSearch: 'location' | 'name') => commandSearch === 'location',
      then: yup.string().required('errors.form.empty'),
      otherwise: yup.string(),
    }),
    alleeCommande: yup.string().when(['commandSearch'], {
      is: (commandSearch: 'location' | 'name') => commandSearch === 'location',
      then: yup.string().required('errors.form.empty'),
      otherwise: yup.string(),
    }),
    standCommande: yup.string().when(['commandSearch'], {
      is: (commandSearch: 'location' | 'name') => commandSearch === 'location',
      then: yup.string().required('errors.form.empty'),
      otherwise: yup.string(),
    }),
  }),
}

const IncidentFormFields: { [key in IncidentStepScreen]: (keyof IncidentForm)[] } = {
  START: [],
  TYPE: ['isInfrastructure'],
  POSITION: ['space'],
  LOCATION: ['location', 'subLocation', 'subsubLocation'],
  ACTIVITY: ['familles'],
  ACTIVITY_DETAIL: ['familles'],
  DETAIL: ['commentaire', 'quantite', 'isPrioritaire'],
  PHOTO: ['photos'],
  PRESTA: ['societePrestataireId'],
  RECAP: [],
  MANIF: ['manifestationId'],
  COMMAND_SEARCH: ['enseigneCommande', 'espaceCommande', 'alleeCommande', 'standCommande'],
  COMMAND_SEARCH_EXPO: ['enseigneCommande', 'espaceCommande', 'alleeCommande', 'standCommande'],
  USER: ['user'],
  USER_DETAIL: ['nomContact', 'prenomContact', 'emailContact', 'telephoneContact'],
  COMMAND: ['numeroCommande', 'referenceArticleCommande'],
  COMMAND_EXPO: ['libelleFamille', 'libelleSousFamille', 'libelleArticle'],
  MANIF_EXPO: ['manifestationId'],
  SITE: ['siteId'],
  SITE_EXPO: ['siteId'],
  MAP: ['plan'],
}

export { IncidentFormScheme, IncidentFormFields }
